/*
 * @Author: Roman
 * @Date: 2022-12-13 11:15:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-02 17:52:18
 * @FilePath: \qpmn-site\src\app\modules\user\rest\anonymous-user-rest-service.ts
 * @Description: 
 */

import { IDataAccessor, AbstractAccessorService } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { IAnonymousResponseUser } from "@modules/basic/page";
import { IAnonymousRestService } from "./anonymous-rest";


export class AnonymousRestService extends AbstractAccessorService<IAnonymousResponseUser> implements IAnonymousRestService {
    public readonly $name: string = "anonymousRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<IAnonymousResponseUser>) {
        super();
    }


    /**
     * @description 匿名用户登录
     * @param anonymousUser 
     */
    public login(anonymousUserId: number): angular.IPromise<IResponse<IAnonymousResponseUser>> {
        return this.$accessor<IAnonymousResponseUser, { anonymousUserId: number }, string>(this.$name, "login", {
            parameter: {
                anonymousUserId: anonymousUserId
            }
        })
    }
}